import React, { useState } from 'react';
import gql from 'graphql-tag';
import useCurrentUser from '../hooks/useCurrentUser';
import WelcomeModal from '../components/WelcomeModal';
import useQuery from '../../modules/react/hooks/useQuery';
import useMutation from '../../modules/react/hooks/useMutation';

const CHECK_USER = gql`
  query CheckCompanyUser($userId: String!) {
    currentCompany(userId: $userId) {
      activeUsers 
    }
  }
`;

const ADD_USER = gql`
  mutation AddUser($userId: String!) {
    addWelcomeUser(userId: $userId) {
      company {
        activeUsers
      }
      userErrors {
        code
        message
      }
    }
  }
`;

const propTypes = {};

const defaultProps = {};

const WelcomeModalContainer = () => {
  const currentUser = useCurrentUser();
  const [show, setShow] = useState(false);

  const { loading } = useQuery(CHECK_USER, {
    variables: {
      userId: currentUser.id,
    },
    onCompleted: data => (data && data.currentCompany ? null : setShow(true)),
  });
  const [
    addWelcomeUser,
  ] = useMutation(ADD_USER);

  if (loading) {
    return null;
  }

  const onDismiss = async () => {
    await addWelcomeUser({
      variables: {
        userId: currentUser.id,
      },
    });
    setShow(false);
  };

  return (
    <WelcomeModal
      onDismiss={onDismiss}
      show={show}
    />
  );
};

WelcomeModalContainer.propTypes = propTypes;
WelcomeModalContainer.defaultProps = defaultProps;

export default WelcomeModalContainer;
